import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CustomDirectivesModule } from "@app/_directives/custom-directives.module";
import { ParseNamePipe } from "@app/_pipes/parse-name.pipe";
import { AngularExpansionModule } from "@app/angular-expansion/angular-expansion.module";
import { ComeAndGoBoxModule } from "@app/components/come-and-go-box/come-and-go-box.module";
import { FrillButtonModule } from "@app/components/frill-button/frill-button.module";
import { RecordComegoWidgetModule } from "@app/components/record-comego-widget/record-comego-widget.module";
import { RecordWidgetModule } from "@app/components/record-widget/record-widget.module";
import { SubscriptionStatusRowModule } from "@app/components/subscription-status-row/subscription-status-row.module";
import { MaterialModule } from "@app/material.module";
import { FabricBaseIconModule } from "@app/modules/fabric/fabric-base-icon/fabric-base-icon.module";
import { WorkspaceDialogModule } from "@app/shared/dialogs/workspace-dialog/workspace-dialog.module";
import { RecordToolbarModule } from "@app/shared/record-toolbar/record-toolbar.module";
import { SharedModule } from "@app/shared/shared.module";
import { UserMenuModule } from "@app/shared/user-menu/user-menu.module";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { DateFnsModule } from "ngx-date-fns";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { ShellComponent } from "./shell.component";
import { ShellRouteNamePipe } from "./shell-route-name.pipe";
import { ShellRouterLinkDirective } from "./shell-router-link.directive";

@NgModule({
	imports: [
		CommonModule,
		AngularExpansionModule,
		TranslateModule,

		MaterialModule,
		RouterModule,
		AngularSvgIconModule,
		CustomDirectivesModule,
		RecordToolbarModule,
		SharedModule,
		WorkspaceDialogModule,
		NgxSkeletonLoaderModule,
		FabricBaseIconModule,
		UserMenuModule,
		DateFnsModule,
		RecordWidgetModule,
		RecordComegoWidgetModule,
		FrillButtonModule,
		SubscriptionStatusRowModule,
		ComeAndGoBoxModule,
		ParseNamePipe,
	],
	declarations: [ShellComponent, ShellRouteNamePipe, ShellRouterLinkDirective],
	providers: [],
})
export class ShellModule {}
